export default {
    appVersionUpdates: {
        title: 'App 版本配置',
        description: '管理客户端的更新版本及全语言更新提示文案。低于设置版本号的客户端将收到更新提示（弹窗或仅提醒，取决于更新类型）。',
        action: {
            publish: '发布新更新',
            disable: '设为无效',
            enable: '恢复有效',
            disableConfirm: '确认将该记录设为无效？无效后客户端将不再拉取此配置。',
            enableConfirm: '确认恢复该记录为有效？',
        },
        filter: {
            time: '发布时间',
            timeAll: '全部时间',
            time7d: '近 7 天',
            time30d: '近 30 天',
            timeCustom: '自定义时间范围',
            customRange: '自定义区间',
            channel: '生效渠道',
            type: '更新类型',
            status: '状态',
            all: '全部',
        },
        table: {
            idTime: '记录 ID / 发布时间',
            channels: '渠道及版本号',
            type: '更新类型',
            status: '状态',
            contents: '更新内容公告',
            publisher: '发布人',
        },
        type: {
            Remind: {
                title: '提醒更新',
                desc: '非阻断性更新，弹窗可关闭。适用于日常迭代、启动检查与设置页版本点击检查。',
            },
            Force: {
                title: '强制更新',
                desc: '阻断性更新，弹窗不可关闭。仅用于重大改版或阻断性 Bug。',
            },
            RemindOnly: {
                title: '提醒不弹窗',
                desc: '非阻断性更新，不弹出更新弹窗，仅在设置页等入口展示有新版本提醒。适用于轻量迭代或不想打断用户的场景。',
            },
            clickHint: '「设置-版本」点击检查与冷/热启动均走服务端下发；Remind / Force 会弹窗，RemindOnly 仅展示提醒不弹窗。',
        },
        status: {
            Enabled: '有效',
            Disabled: '无效',
        },
        channel: {
            ios: {
                label: 'iOS 渠道',
                short: 'iOS',
            },
            android: {
                label: 'Android (Google Play)',
                short: 'Android',
            },
            apk: {
                label: '官网独立 APK',
                short: 'APK',
            },
        },
        form: {
            updateType: '更新类型',
            channels: '生效渠道、版本判定与更新链接',
            channelsHint: '勾选需要下发更新的渠道，并填写最低通行版本号及跳转链接。未勾选的渠道视为本次无更新。',
            versionThreshold: '低于该版本弹窗',
            downloadUrl: '跳转更新链接',
            i18n: '更新内容与多语言文案公告',
            i18nHint: '客户端按系统语言匹配文案；未配置语种默认回退英文 (EN)。',
        },
        i18n: {
            zh: { required: '🇨🇳 ZH (必填)' },
            en: { required: '🇺🇸 EN (必填)' },
            ja: '🇯🇵 JA',
            es: '🇪🇸 ES',
            vi: '🇻🇳 VI',
            tr: '🇹🇷 TR',
        },
        modal: {
            createTitle: '发布 App 更新配置',
            editTitle: '编辑配置 ({id})',
            submit: '确认提交',
        },
        validation: {
            channelRequired: '请至少选择一个生效渠道',
            iosVersionRequired: '请输入 iOS 版本号',
            iosVersionFormat: 'iOS 版本号格式应为 x.y.z',
            iosUrlRequired: '请输入 iOS 跳转链接',
            androidVersionRequired: '请输入 Android 版本号',
            androidVersionFormat: 'Android 版本号格式应为 x.y.z',
            androidUrlRequired: '请输入 Android 跳转链接',
            apkVersionRequired: '请输入 APK 版本号',
            apkVersionFormat: 'APK 版本号格式应为 x.y.z',
            apkUrlRequired: '请输入 APK 下载链接',
            zhRequired: '简体中文 (ZH) 为必填项',
            enRequired: '英文 (EN) 为必填项',
        },
        message: {
            loadFailed: '加载失败',
            saveFailed: '保存失败',
            createSuccess: '发布成功',
            updateSuccess: '修改已保存',
            statusUpdated: '状态已更新',
        },
    },
};
